export const trackFormSubmission = (formId: string) => {
  if (typeof window !== "undefined" && (window as any)._hsq) {
    (window as any)._hsq.push(["trackFormSubmission", formId]);
  } else {
    console.warn("HubSpot tracking code is not loaded");
  }
};
